document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu--hulfe-shop').forEach((menu) => {
    const preview = menu.querySelector('[data-hulfe-shop-preview]');
    const image = menu.querySelector('[data-hulfe-shop-preview-image]');
    const links = [...menu.querySelectorAll('[data-hulfe-preview-src]')];
    if (!preview || !image || links.length === 0) return;

    const defaultSrc = image.getAttribute('src');
    const defaultAlt = image.getAttribute('alt') || '';
    let fadeTimer;

    const setPreview = (src, alt) => {
      if (!src || image.getAttribute('src') === src) return;
      window.clearTimeout(fadeTimer);
      preview.classList.add('is-changing');
      const preload = new Image();
      preload.onload = () => {
        image.src = src;
        image.alt = alt || '';
        requestAnimationFrame(() => preview.classList.remove('is-changing'));
      };
      preload.src = src;
    };

    const resetPreview = () => setPreview(defaultSrc, defaultAlt);

    links.forEach((link) => {
      const activate = () => setPreview(link.dataset.hulfePreviewSrc, link.dataset.hulfePreviewAlt);
      link.addEventListener('mouseenter', activate);
      link.addEventListener('focus', activate);
    });

    menu.addEventListener('mouseleave', resetPreview);
    menu.addEventListener('toggle', () => {
      if (!menu.open) resetPreview();
    });
  });
});
